import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { logout, refreshSession } from '../actions/constants'
import { IWhatToDoItem } from '../../models/what_to_do'
import { IFlashNews } from '../../models/flash_news'
import { IAboutNH } from '../../models/about_nh'

export interface ISupportState {
  aboutMembership: string
  aboutNH: IAboutNH
  whatToDos?: IWhatToDoItem[]
  flashNews?: IFlashNews
}

const initialState: ISupportState = {
  aboutMembership: '',
  aboutNH: {
    title: '',
    content: ''
  },
  whatToDos: []
}

export const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setAboutMembership: (state, action: PayloadAction<string>) => {
      state.aboutMembership = action.payload
    },
    setAboutNH: (state, action: PayloadAction<IAboutNH>) => {
      state.aboutNH = action.payload
    },
    setWhatToDos: (state, action: PayloadAction<IWhatToDoItem[]>) => {
      state.whatToDos = action.payload
    },
    setFlashNews: (state, action: PayloadAction<IFlashNews | undefined>) => {
      state.flashNews = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const {
  setAboutMembership,
  setAboutNH,
  setWhatToDos,
  setFlashNews
} = supportSlice.actions

export default supportSlice.reducer
